<template>
  <div>
    <h2>{{ $t('online.percentageCalculator.percentageFromSum.title') }}</h2>
    <p>{{ percentageFromSumDescription }}</p>
    <v-text-field
      :label="$t('online.percentageCalculator.baseSum')"
      v-model="percentageFromSum.baseSum"
      type="number"
      clearable
    />
    <v-text-field
      :label="$t('online.percentageCalculator.percentage')"
      v-model="percentageFromSum.percentage"
      type="number"
      clearable
    />
    <div>
      {{ $t('online.percentageCalculator.result') }}: <b> {{ percentageFromSumResult }} </b>
    </div>

    <v-spacer/>

    <h2>{{ $t('online.percentageCalculator.percentageAddition.title') }}</h2>
    <p>{{ percentageAdditionDescription }}</p>
    <p>{{ $t('online.percentageCalculator.percentageAddition.note') }}</p>
    <v-text-field
      :label="$t('online.percentageCalculator.baseSum')"
      v-model="percentageAddition.baseSum"
      type="number"
      clearable
    />
    <v-text-field
      :label="$t('online.percentageCalculator.percentage')"
      v-model="percentageAddition.percentage"
      type="number"
      clearable
    />
    <div>
      {{ $t('online.percentageCalculator.result') }}: <b> {{ percentageAdditionResult }} </b>
    </div>

    <v-spacer/>

    <h2>{{ $t('online.percentageCalculator.percentageCount.title') }}</h2>
    <p>{{ percentageCountDescription }}</p>
    <v-text-field
      :label="$t('online.percentageCalculator.baseSum')"
      v-model="percentageCount.baseSum"
      type="number"
      clearable
    />
    <v-text-field
      :label="$t('online.percentageCalculator.partialSum')"
      v-model="percentageCount.partialSum"
      type="number"
      clearable
    />
    <div>
      {{ $t('online.percentageCalculator.result') }}: <b> {{ percentageCountResult }}% </b>
    </div>

    <v-spacer/>

    <h2>{{ $t('online.percentageCalculator.percentageGain.title') }}</h2>
    <p>{{ percentageGainDescription }}</p>
    <v-text-field
      :label="$t('online.percentageCalculator.baseSum')"
      v-model="percentageGain.baseSum"
      type="number"
      clearable
    />
    <v-text-field
      :label="$t('online.percentageCalculator.endSum')"
      v-model="percentageGain.endSum"
      type="number"
      clearable
    />
    <div>
      {{ $t('online.percentageCalculator.result') }}: <b> {{ percentageGainResult }}% </b>
    </div>

  </div>
</template>

<script>

const debounce = (fn, delay) => {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
};

export default {
  name: "PercentageCalculator",
  data() {
    return {
      percentageFromSum: { baseSum: 128, percentage: 5 },
      percentageAddition: { baseSum: 521, percentage: 16 },
      percentageCount: { baseSum: 332, partialSum: 34 },
      percentageGain: { baseSum: 425, endSum: 472 },
      calcPercentageFromSum: { baseSum: 128, percentage: 5 },
      calcPercentageAddition: { baseSum: 521, percentage: 16 },
      calcPercentageCount: { baseSum: 332, partialSum: 34 },
      calcPercentageGain: { baseSum: 425, endSum: 472 },
    };
  },
  watch: {
    percentageFromSum: {
      deep: true,
      handler: debounce(function(val) { this.calcPercentageFromSum = { ...val }; }, 300),
    },
    percentageAddition: {
      deep: true,
      handler: debounce(function(val) { this.calcPercentageAddition = { ...val }; }, 300),
    },
    percentageCount: {
      deep: true,
      handler: debounce(function(val) { this.calcPercentageCount = { ...val }; }, 300),
    },
    percentageGain: {
      deep: true,
      handler: debounce(function(val) { this.calcPercentageGain = { ...val }; }, 300),
    },
  },
  computed: {
    percentageFromSumDescription() {
      return this.$t('online.percentageCalculator.percentageFromSum.description',
        [this.calcPercentageFromSum.percentage, this.calcPercentageFromSum.baseSum]);
    },
    percentageFromSumResult() {
      return this.calcPercentageFromSum.percentage / 100 * this.calcPercentageFromSum.baseSum;
    },
    percentageAdditionDescription() {
      return this.$t('online.percentageCalculator.percentageAddition.description',
        [this.calcPercentageAddition.baseSum, this.calcPercentageAddition.percentage]);
    },
    percentageAdditionResult() {
      let baseSum = parseFloat(this.calcPercentageAddition.baseSum);
      let percentage = parseFloat(this.calcPercentageAddition.percentage);
      return baseSum + (percentage / 100 * baseSum);
    },
    percentageCountDescription() {
      return this.$t('online.percentageCalculator.percentageCount.description',
        [this.calcPercentageCount.partialSum, this.calcPercentageCount.baseSum]);
    },
    percentageCountResult() {
      let baseSum = parseFloat(this.calcPercentageCount.baseSum);
      let partialSum = parseFloat(this.calcPercentageCount.partialSum);
      return partialSum / baseSum * 100;
    },
    percentageGainDescription() {
      return this.$t('online.percentageCalculator.percentageGain.description',
        [this.calcPercentageGain.endSum, this.calcPercentageGain.baseSum]);
    },
    percentageGainResult() {
      let baseSum = parseFloat(this.calcPercentageGain.baseSum);
      let endSum = parseFloat(this.calcPercentageGain.endSum);
      return (endSum - baseSum) / baseSum * 100;
    },
  },
};

</script>

<style scoped>
h2 {
  margin-top: 30px;
  margin-bottom: 20px;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>